import req from "api";

const USER_RESETPASSWORD = "/user/resetpassword";

/**
 *
 * @param {object} data
 * @param {string} data.email_address
 * @returns
 */
export const submitResetPassword = data =>
  req.post(USER_RESETPASSWORD, { ...data });

/**
 *
 * @param {object} params
 * @param {string} params.ResetToken
 * @param {object} data
 * @param {string} data.password
 * @returns
 */ export const updatePassword = (params, data) =>
  req.patch(USER_RESETPASSWORD, { ...data }, { params: { ...params } });
